const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("src/pages/hmware/LoginPage.vue"),
    meta: {
      isAuth: true,
    },
  },
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "queue",
        component: () => import("src/pages/hmware/QueuePage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "stock-adjustment",
        component: () => import("src/pages/hmware/StockAdjustmentPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING",
            "ROLE_MAINTENANCE",
          ],
        },
      },
      {
        path: "history",
        component: () => import("src/pages/hmware/HistoryPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "stock",
        component: () => import("src/pages/hmware/StockPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "positions/:physicalPositionId?",
        component: () => import("src/pages/hmware/PositionsPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "warehouse",
        component: () => import("src/pages/hmware/WareHouseViewerPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "cameras",
        component: () => import("src/pages/hmware/CamerasPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "containers-type",
        component: () => import("src/pages/hmware/ContainersTypePage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING",
          ],
        },
      },
      {
        path: "items",
        component: () => import("src/pages/hmware/ItemsPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "rotation-zone",
        component: () => import("src/pages/hmware/RotationZonePage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "alarms",
        component: () => import("src/pages/hmware/AlarmsPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "containers",
        component: () => import("src/pages/hmware/ContainersPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "families",
        component: () => import("src/pages/hmware/FamiliesPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING"
          ],
        },
      },
      {
        path: "params",
        component: () => import("src/pages/hmware/ParamsPage.vue"),
        meta: { authorize: ["ROLE_ADMIN", "ROLE_SUPERADMIN"] },
      },
      {
        path: "kpi",
        component: () => import("src/pages/hmware/DashboardPage.vue"),
        meta: { authorize: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_USER","ROLE_ENGINEERING"] },
      },
      {
        path: "logs",
        component: () => import("src/pages/hmware/LogsPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN"] },
      },
      {
        path: "users",
        component: () => import("src/pages/hmware/UsersPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ADMIN"] },
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import("src/pages/hmware/SettingsPage.vue"),
        meta: {
          authorize: [
            "ROLE_ADMIN",
            "ROLE_USER",
            "ROLE_SUPERADMIN",
            "ROLE_ENGINEERING",
          ],
        },
      },
      {
        path: "configuration",
        component: () => import("src/pages/hmware/ConfigurationPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN"] },
      },
      {
        path: "totalinboundspage",
        component: () => import("src/pages/hmware/TotalInboundsPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN"] },
      },
      {
        path: "totaloutboundspage",
        component: () => import("src/pages/hmware/TotalOutboundsPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN"] },
      },
      {
        path: "tasks",
        component: () => import("src/pages/hmware/TasksPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ADMIN"] },
      },
      {
        path: "system-logs",
        component: () => import("src/pages/hmware/SystemLogsPage.vue"),
        meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ADMIN", "ROLE_ENGINEERING"] },
      },
      {
        path: "cmlogic",
        meta: { authorize: ["ROLE_SUPERADMIN","ROLE_ENGINEERING"] },
        children: [
            // CM Logic
            {
              path: "machine-errors",
              component: () => import("src/pages/cmlogic/MachineErrorPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "plc-params",
              component: () => import("src/pages/cmlogic/PlcParamsPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "machines",
              component: () => import("src/pages/cmlogic/MachinesPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "acquisition",
              component: () => import("src/pages/cmlogic/AcquisitionPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "kpi",
              component: () => import("src/pages/cmlogic/KpiPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "scanners",
              component: () => import("src/pages/cmlogic/ScannersPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "screenshots/:machineRequestId?",
              component: () => import("src/pages/cmlogic/PlcScreenshotsPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "queue",
              component: () => import("src/pages/cmlogic/QueuePage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "history",
              component: () => import("src/pages/cmlogic/HistoryPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN","ROLE_ENGINEERING"] },
            },
            {
              path: "pallets",
              component: () => import("src/pages/cmlogic/PalletsPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            },
            {
              path: "positions",
              component: () => import("src/pages/cmlogic/PhysicalPositionsPage.vue"),
              meta: { authorize: ["ROLE_SUPERADMIN", "ROLE_ENGINEERING"] },
            }
          ],
        },
    ],
    meta: {
      requiresAuth: true,
    },
  },


  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("src/pages/hmware/ErrorNotFound.vue"),
  },
];

export default routes;
